import { useState, useEffect } from 'react'

import Api from 'services/api'

import { useSessionContext } from 'hooks/SessionContext'

export const defaultDealer = {
  criticalAlertCount: 0,
  majorAlertCount: 0,
  minorAlertCount: 0,
  sdaAlertCount: 0,
  sdaMajorAlertCount: 0,
  sdaMinorAlertCount: 0,
  sdaCriticalAlertCount: 0,
  connectedCount: 0,
  disconnectedCount: 0,
  dirtyFilterCount: 0,
  activeServiceContractCount: 0,
  expiredServiceContractCount: 0,
  nonServiceContractCount: 0,
  hehmSDACriticalAlarmCount: 0,
  hehmSDAMajorAlarmCount: 0,
  hehmSDAMinorAlarmCount: 0,
  hehmHealthScoreCriticalCount: 0,
  hehmHealthScoreFairCount: 0,
  hehmHealthScoreGreatCount: 0,
  hehmFilterHealthScoreNeedsReplacementCount: 0,
  hehmFilterHealthScoreFairCount: 0,
  hehmDisconnected24HoursCount: 0,
  hehmDisconnected7DaysCount: 0,
  channel: ''
}

const useDealer = (refreshTimestamp) => {
  const { session: { dealerId, isAdmin } } = useSessionContext()

  const [dealer, setDealer] = useState(defaultDealer)
  const [isDealerLoaded, setIsDealerLoaded] = useState(false)

  useEffect(() => {
    setDealer(defaultDealer)

    if (!dealerId) return

    Api.Dealers.get(dealerId)
      .then((res) => {
        setDealer(res)
        setIsDealerLoaded(true)
      })
      .catch(() => {
        setDealer(defaultDealer)
        setIsDealerLoaded(true)
      })
  }, [dealerId, isAdmin, refreshTimestamp])

  return { dealer, isDealerLoaded }
}

export default useDealer
